import { useContext } from 'react';
import { createContext } from 'react';

import { LinkProps } from '../@types/LinkProps';

export const LinkContext = createContext<LinkProps>({} as LinkProps);

LinkContext.displayName = 'Link';

const LinkProvider = (props: LinkProps) => <LinkContext.Provider value={props}>{props.children}</LinkContext.Provider>;

export const useLink = () => {
	const context = useContext(LinkContext);

	return context;
};

export default LinkProvider;
